// ---------------------------------------------------------------------------
// Project-board email alerts (ported from Monday v2's emailService).
// Fires an EmailJS notification when Al or Phil is assigned/ @-mentioned on a
// board task. Uses EmailJS's REST API via fetch — no SDK dependency. The
// service/template/public keys are public client-side EmailJS values by design.
//
// TODO: paste the three EmailJS values below to switch from "simulation"
// (console only) to real sending. Recipients can be changed here too.
// ---------------------------------------------------------------------------
import { auth } from '../firebase';

const EMAILJS = {
  serviceId: 'service_5jxh7gv',    // EmailJS Service ID
  templateId: 'template_4pe4ggp',  // EmailJS Template ID
  publicKey: 'Hfe0spDgovX0XDj7j',  // EmailJS Public Key (safe for browser; do NOT add the Private Key here)
};

const RECIPIENTS = {
  al:   { email: 'Al@teamcmg.com', name: 'Al Garcia' },
  phil: { email: 'phil@teamcmg.com', name: 'Phil' },
};

const EMAILJS_ENDPOINT = 'https://api.emailjs.com/api/v1.0/email/send';

async function sendAlert(who, params) {
  const { serviceId, templateId, publicKey } = EMAILJS;
  const recipient = RECIPIENTS[who];

  // Not configured yet → simulate (log only), matching the original app's behavior.
  if (!serviceId || !templateId || !publicKey) {
    console.warn(`EmailJS not configured — simulating ${recipient.name} alert:`, params);
    return;
  }

  // Don't email yourself for your own action.
  const me = auth.currentUser?.email?.toLowerCase();
  if (me && me === recipient.email.toLowerCase()) return;

  const now = new Date();
  try {
    const res = await fetch(EMAILJS_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        service_id: serviceId,
        template_id: templateId,
        user_id: publicKey,
        template_params: {
          to_email: recipient.email,
          to_name: recipient.name,
          name: auth.currentUser?.displayName || auth.currentUser?.email || 'A team member',
          task_name: params.taskName,
          client_name: params.clientName,
          message: params.notes || 'No notes provided',
          notes: params.notes || 'No notes provided',
          time: now.toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }),
          timestamp: now.toLocaleString(),
          tagged_in: params.taggedIn,
        },
      }),
    });
    if (!res.ok) throw new Error(`EmailJS responded ${res.status}`);
  } catch (err) {
    console.error(`Failed to send ${recipient.name} alert:`, err);
  }
}

export const sendAlGarciaAlert = (params) => sendAlert('al', params);
export const sendPhilAlert = (params) => sendAlert('phil', params);

// Returns which people are newly tagged in a text transition (for notes/comments).
// `prev` may be '' for fresh comments.
export function newlyTagged(prevText, nextText) {
  const prev = (prevText || '').toLowerCase();
  const next = (nextText || '').toLowerCase();
  const isTagged = (t, who) => who === 'al'
    ? (t.includes('@al garcia') || t.includes('@al'))
    : (t.includes('@phil garcia') || t.includes('@phil'));
  return {
    al: isTagged(next, 'al') && !isTagged(prev, 'al'),
    phil: isTagged(next, 'phil') && !isTagged(prev, 'phil'),
  };
}
